import React from 'react';
import { Select, SelectItem, SelectInnerItem } from 'ui/Input';
import KeyboardDatePickerWithState from 'ui/DatePicker/KeyboardDatePickerWithState/KeyboardDatePickerWithState';
import { Address } from 'components/modules/BranchLocator/BranchLocator.model';
import { IAccount } from 'store/accounts.model';

const renderSourceAccountField = (accounts: IAccount[], submitting: boolean) => (
  <Select name="sourceAccount" label="Source Account" disabled={submitting}>
    {accounts.map(({ accountNumber }) => (
      <SelectItem value={accountNumber} key={accountNumber}>
        {accountNumber}
      </SelectItem>
    ))}
  </Select>
);

const renderStartDateField = (submitting: boolean, handleChangeDate: (value: string) => void) => (
  <KeyboardDatePickerWithState
    name="startDate"
    label="Start Date"
    disableFuture
    disabled={submitting}
    handleChangeDate={handleChangeDate}
  />
);

const renderEndDateField = (submitting: boolean, handleChangeDate: (value: string) => void) => (
  <KeyboardDatePickerWithState
    name="endDate"
    label="End Date"
    disableFuture
    disabled={submitting}
    handleChangeDate={handleChangeDate}
  />
);

export const renderBranchesField = (branches: Address[], submitting: boolean) => (
  <Select name="branch" label="Pick-up Location/Branch" disabled={submitting}>
    {branches.map(({ BranchSortCode, BranchName }) => (
      <SelectItem value={BranchName} key={BranchSortCode}>
        <SelectInnerItem value={BranchName} label="" />
      </SelectItem>
    ))}
  </Select>
);

const renderOfficialStatementFields = (
  accounts: IAccount[],
  branches: Address[],
  submitting: boolean,
  handleChangeStartDate: (value: string) => void,
  handleChangeEndDate: (value: string) => void,
) => (
  <>
    {renderSourceAccountField(accounts, submitting)}
    {renderStartDateField(submitting, handleChangeStartDate)}
    {renderEndDateField(submitting, handleChangeEndDate)}
    {renderBranchesField(branches, submitting)}
  </>
);

export default renderOfficialStatementFields;
